import type { TreeModel, StoryElementReference, BBModelTextChild, BBSymbolLink } from 'types/story';
import { isStoryElementReference } from './story-element-reference';

type AllowedTypes = TreeModel | BBSymbolLink;

/**
 * Walk components depth-first and call a callback on each
 *
 * @function componentWalk
 * @param components  - Array of components
 * @param cb          - callback to run on each component
 * @param path        - dot-notated path to component in components param
 * @param parent      - parent component
 * @example
 *      const arr: (TreeModel | BBSymbolLink)[] = [];
 *
 *      componentWalk(arr, function step({ component }) {
 *          if ('children' in component) componentWalk(component.children, step);
 *      });
 *
 * @return void
 */

// TODO: refactor and pass params as a single object componentWalk({ components, cb, path, parent })
export const componentWalk = <T extends AllowedTypes = AllowedTypes>(
	components: (T | StoryElementReference)[] | BBModelTextChild,
	cb: (props: { component: T; index: number; path: string; parent?: TreeModel }) => void,
	path: string = '',
	parent?: TreeModel
) => {
	if (!Array.isArray(components)) {
		return;
	}
	components.forEach((component, index) => {
		if (!component || isStoryElementReference(component)) {
			return;
		}

		cb({
			component,
			index,
			path: path === '' ? `${index}` : `${path}.children.${index}`,
			parent,
		});
	});
};
